
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { logoutAction } from "../../../store/actions/authActions";
import LanguageDropdown from './LanguageDropDown';


const Header = (props) => {

    const { history } = props;
    const dispatch = useDispatch();

    // const initialState = {
    //     isSearch: false,
    //     open: false,
    //     position: 'right',
    // }
    // const [state, setState] = useState(initialState);
    const { token } = useSelector((state) => state.auth)

    const logOut = () => {
        dispatch(logoutAction())

    }

    useEffect(() => {
        if (!token) {
            history.push('/login')
        }
    }, [token, history])


    const toggleMenu = () => {
        props.toggleMenuCallback();
    }

    // const toggleRightDrawer = () => {
    //     setState({ position: 'right' });
    //     setState({ open: !state.open });
    // }

    // const closeDrawer = () => {
    //     setState({ open: false });
    // }

    // const onDrawerClose = () => {
    //     setState({ open: false });
    // }

    const toggleFullscreen = () => {
        if (
            !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen()
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen()
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                )
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen()
            }
        }
    }


    return (
        <React.Fragment>
            <header id="page-topbar">
                <div className="navbar-header">
                    <div className="d-flex">
                        <button
                            type="button"
                            onClick={toggleMenu}
                            className="btn btn-sm px-3 font-size-16 header-item"
                            id="vertical-menu-btn"
                        >
                            <i className="fa fa-fw fa-bars"></i>
                        </button>
                    </div>

                    <div className="d-flex">
                        <LanguageDropdown />
                        <div className="dropdown d-none d-lg-inline-block ms-1">
                            <div className="d-flex">
                                <button
                                    type="button"
                                    onClick={toggleFullscreen}
                                    className="d-flex align-items-center btn header-item noti-icon"
                                    data-toggle="fullscreen"
                                >
                                    <i className="bx bx-fullscreen"></i>
                                </button>
                                <button
                                    onClick={logOut}
                                    type="button"
                                    className="d-flex align-items-center btn header-item noti-icon"
                                >
                                    <i className="bx bx-log-out"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </React.Fragment>
    )

}

export default Header;